/* eslint-disable import/no-extraneous-dependencies */
import React from 'react'
import Disclaimer from 'components/disclaimer.coffee'
import styles from './EasinsureDisclaimer.scss'

export const EasinsureDisclaimer = () => (
    <div className={styles.disclaimer}>
        <Disclaimer/>
        {`© ${(new Date()).getFullYear()} WILLEMOT NV `}
    </div>
)




// WEBPACK FOOTER //
// ./components/easinsure/disclaimer/EasinsureDisclaimer.jsx